import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  useGetCitationStyles,
  useGetCitation,
  useGetCitationLocales,
} from "./hooks";
import { Dropdown, Button, Loader, Message } from "semantic-ui-react";

const CitationFormatter = ({ doi }) => {
  const [selectedStyle, setSelectedStyle] = useState(null);
  const [selectedLocale, setSelectedLocale] = useState(null);
  const [citation, setCitation] = useState("");
  const [copySuccess, setCopySuccess] = useState(false);

  const { data: styles = [], isLoading: stylesLoading } =
    useGetCitationStyles();
  const { data: locales = [], isLoading: localesLoading } =
    useGetCitationLocales();

  const { refetch: fetchCitation } = useGetCitation(
    doi,
    selectedStyle,
    selectedLocale,
  );

  const handleGetCitation = async () => {
    const { data } = await fetchCitation();
    setCitation(data);
  };

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(citation);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 3000);
  };

  return (
    <>
      <h4>Citation</h4>
      <div style={{ marginBottom: "1em" }}>
        <label>Select Style:</label>
        {stylesLoading ? (
          <Loader active inline size="small" />
        ) : (
          <Dropdown
            placeholder="Select a style"
            fluid
            search
            selection
            options={styles.map((style) => ({
              key: style,
              value: style,
              text: style,
            }))}
            onChange={(e, { value }) => setSelectedStyle(value)}
          />
        )}
      </div>
      <div style={{ marginBottom: "1em" }}>
        <label>Select Locale:</label>
        {localesLoading ? (
          <Loader active inline size="small" />
        ) : (
          <Dropdown
            placeholder="Select a locale"
            fluid
            search
            selection
            options={locales.map((locale) => ({
              key: locale,
              value: locale,
              text: locale,
            }))}
            onChange={(e, { value }) => setSelectedLocale(value)}
          />
        )}
      </div>
      <Button
        secondary
        onClick={handleGetCitation}
        disabled={!selectedStyle || !selectedLocale}
      >
        Get Citation
      </Button>
      {citation && (
        <div style={{ marginTop: "1em" }}>
          <Message>
            <Message.Header>Citation</Message.Header>
            <p>{citation}</p>
          </Message>
          <div style={{ display: "flex", alignItems: "center", gap: "1em" }}>
            <Button secondary onClick={handleCopyToClipboard}>
              Copy to Clipboard
            </Button>
            {copySuccess && (
              <span style={{ color: "green" }}>Copied to clipboard!</span>
            )}
          </div>
        </div>
      )}
    </>
  );
};

CitationFormatter.propTypes = {
  doi: PropTypes.string.isRequired,
};

export default CitationFormatter;
